import React from 'react';

import { MdLock } from 'react-icons/md';

import { Modal } from 'antd';

import {
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './styles';

export default function ModalDesbloqueioUsuario({
  desloquearUsuario,
  cancelarDesloquearUsuario,
  resquestDesbloquearUsuario,
}) {
  const handleCancel = () => {
    cancelarDesloquearUsuario();
  };

  const handleOk = () => {
    resquestDesbloquearUsuario();
  };

  return (
    <Modal
      visible={desloquearUsuario}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="Conferir depois"
      centered
      footer={null}
      width="480px"
    >
      <ModalContainer>
        <ModalHeader>
          <div className="iconModal">
            <span>
              <MdLock size={30} />
            </span>
          </div>
          <h2>
            Confirmar <span>desbloqueio de usuários </span>
          </h2>
        </ModalHeader>
        <div className="ModalBody">
          <p>
            O acesso ao sistema é bloqueado toda vez que um usuário executa 05
            falhas sucessivas de login (erro de login e senha). Você está certo
            de que deseja prosseguir com o desbloqueio?
          </p>
        </div>
      </ModalContainer>

      <ModalFooter>
        <ButtonModal type="button" onClick={handleOk}>
          Desbloquear
        </ButtonModal>
        <ButtonModal type="button" cancel onClick={handleCancel}>
          Cancelar
        </ButtonModal>
      </ModalFooter>
    </Modal>
  );
}
